import { render, staticRenderFns } from "./DraggableElements.vue?vue&type=template&id=54806e5c&scoped=true&"
import script from "./DraggableElements.vue?vue&type=script&lang=js&"
export * from "./DraggableElements.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElements.vue?vue&type=style&index=0&id=54806e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54806e5c",
  null
  
)

export default component.exports